import React, { Component } from "react";

import Search from "../search";

export default class Empty extends Component {
	render() {
		return (
			<div className="ladder-empty-target">
				<div className="ladder-addition clearfix">
					<Search />
				</div>
				<div className="error">
					<h3>个人资料不可用</h3>
					<h4>该个人资料无法显示，可能是以下某个原因：</h4>
					<ul>
						<li><i>1</i>该账号在很长一段时间内不够活跃，因此无法显示。要再次显示资料，非活跃的账号必须先登录《暗黑破坏神Ⅲ》</li>
						<li><i>2</i>该账号不存在</li>
					</ul>
				</div>
			</div>
		);
	}
}